export const BRAND_COLORS = {
  primary: "#2dc6fe",
  secondary: "#81fbef",
  accent: "#FF004C",
  info: "#83D6DB",
  success: "#10b981",
  dark: "#0B4A55",
  blueLight: "#4784AF",
};

export const SEMANTIC_COLORS = {
  successDark: "#166534",
  successLight: "#86efac",
  errorDark: "#dc2626",
  barTrack: "#e8f8ff",
};
